
import { useLanguage } from '@/hooks/useLanguage';
import { NavLink } from './NavLink';
import { ThemeToggle } from '../ThemeToggle';
import { cn } from '@/lib/utils';

interface MobileNavProps {
  isOpen: boolean;
  isRouteActive: (path: string) => boolean;
  onLinkClick: () => void;
}

export function MobileNav({ isOpen, isRouteActive, onLinkClick }: MobileNavProps) {
  const { t } = useLanguage();

  return (
    <div
      className={cn(
        "lg:hidden transition-all duration-300 ease-in-out overflow-hidden glass-navbar",
        isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
      )}
    >
      <div className="px-2 pt-2 pb-3 space-y-1 flex flex-col">
        <NavLink
          to="/"
          isActive={isRouteActive('/') || isRouteActive('/dashboard')}
          onClick={onLinkClick}
        >
          {t('navbar.dashboard')}
        </NavLink>
        <NavLink
          to="/news"
          isActive={isRouteActive('/news')}
          onClick={onLinkClick}
        >
          {t('navbar.news')}
        </NavLink>
        <NavLink
          to="/leaks"
          isActive={isRouteActive('/leaks')}
          onClick={onLinkClick}
        >
          {t('navbar.leaks')}
        </NavLink>
        <NavLink
          to="/CVE"
          isActive={isRouteActive('/CVE')}
          onClick={onLinkClick}
        >
          {t('navbar.cve')}
        </NavLink>
        <NavLink
          to="/ransomware"
          isActive={isRouteActive('/ransomware')}
          onClick={onLinkClick}
        >
          {t('navbar.ransomware')}
        </NavLink>
        <NavLink
          to="/eol"
          isActive={isRouteActive('/eol')}
          onClick={onLinkClick}
        >
          {t('navbar.eol')}
        </NavLink>
        <NavLink
          to="/releases"
          isActive={isRouteActive('/releases')}
          onClick={onLinkClick}
        >
          {t('navbar.releases')}
        </NavLink>
        <NavLink
          to="/scan"
          isActive={isRouteActive('/scan')}
          onClick={onLinkClick}
        >
          {t('navbar.scan')}
        </NavLink>

        <div className="mt-3 px-3 py-2">
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
}
